import { deepDives } from "@/mocks/home";

export default function DeepDiveSection() {
  return (
    <section className="w-full bg-secondary-950 px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1360px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-9">
          <div>
            <span className="text-[11px] font-label tracking-[0.24em] text-accent-400">DEEP DIVE</span>
            <h2 className="mt-2 font-heading text-3xl md:text-[2.4rem] font-black text-secondary-50">
              深挖专题，换个角度再看一遍
            </h2>
          </div>
          <a
            href="#board"
            className="inline-flex items-center gap-2 text-sm font-label text-secondary-200 hover:text-accent-400 transition-colors whitespace-nowrap"
          >
            全部专题
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {deepDives.map((item) => (
            <a
              key={item.title}
              href="#archive"
              className="group flex flex-col rounded-lg overflow-hidden bg-secondary-900 border border-secondary-800 hover:border-accent-500 transition-colors"
            >
              <div className="w-full h-[210px] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  title={`热点黑料深挖 ${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <span className="text-[11px] font-label tracking-[0.14em] text-accent-400">{item.tag}</span>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-secondary-50 group-hover:text-accent-300 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-xs leading-relaxed text-secondary-300 flex-1">{item.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-label text-secondary-400">
                  <i className="ri-stack-line" />
                  {item.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}